<template>
  <div>
    <ui-modal ref="reporte-ps-modal"
              title="Reporte de planificacion semanal"
              size="large"
              @close="closeReportModal()">

      <div>
        <!-- Row 1 -->
        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="Año"
            placeholder="Seleccionar"
            v-model="anioModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psFiltroAnios"
          />
          <ui-select
            class="w-50"
            has-search
            label="Semana"
            placeholder="Seleccionar"
            v-model="semanaModel"
            :options="psFiltroSemanas"
          />
        </div>
        <!-- Row 2 -->
        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="Cliente"
            placeholder="Seleccionar"
            v-model="clienteModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psFiltroClientes"
          />
          <ui-select
            class="w-50"
            has-search
            label="Puerto Destino"
            placeholder="Seleccionar"
            v-model="puertoModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psFiltroPuertos"
          />
        </div>
        <!-- Row 3 -->
        <div class="d-flex">
          <ui-select
            class="w-50 mr-3"
            has-search
            label="Contenedor"
            placeholder="Seleccionar"
            v-model="contenedorModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psFiltroContenedores"
          />
          <ui-select
            class="w-50"
            has-search
            label="Producto"
            placeholder="Seleccionar"
            v-model="productoModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="psFiltroProductos"
          />
        </div>
        <div class="d-flex">
          <ui-select
            class="w-50"
            has-search
            label="Servicio Integral"
            placeholder="Seleccionar"
            v-model="servicioIntegralModel"
            :keys="{ label: 'name', value: 'id' }"
            :options="[{ id: '1', name: 'Sí' },{ id: '0', name: 'No' }]"
          />
        </div>
      </div>
      <div class="d-flex justify-content-between mt-5">
        <div style="float: left;">
          <button class="btn btn-default ml-2" @click="closeModal('reporte-ps-modal')">
            Cerrar
          </button>
          <button class="btn btn-default ml-2" @click="clear" :disabled="!psEnabledButtons">
            Limpiar
          </button>
        </div>
        <div style="float: right;">
          <button class="btn btn-outline-danger ml-2" :disabled="!psEnabledButtons" @click="generarReporte(1)">
            Reporte general
          </button>
          <button class="btn btn-outline-danger ml-2" :disabled="!psEnabledButtons" @click="generarReporte(2)">
            Reporte Anual
          </button>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>

import UiModal from "keen-ui/src/UiModal";
import { mapActions, mapState } from "vuex";
import { downloadReportePlanificacionSemanal } from "@/constants/lineas";
import uuid from "keen-ui/src/helpers/uuid";

export default {
  components: { UiModal },
  data() {
    return {
      anioModel: "",
      clienteModel: "",
      contenedorModel: "",
      productoModel: "",
      puertoModel: "",
      servicioIntegralModel: "",
      semanaModel: ""
    };
  },
  computed: {
    ...mapState("lineas", [
        "psShowReportModal",
        "psFiltroAnios",
        "psFiltroPuertos",
        "psFiltroContenedores",
        "psFiltroProductos",
        "psFiltroClientes",
        "psFiltroSemanas",
        "psEnabledButtons",
        "psCurrentWeeks"
      ]
    )
  },
  methods: {
    ...mapActions(["ActionSetZindexTablaModal"]),
    ...mapActions("lineas", [
      "actionSetPSEnabledButtons",
      "actionSetPSShowReportModal"
    ]),
    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },
    clear() {
      this.anioModel = "";
      this.clienteModel = "";
      this.contenedorModel = "";
      this.productoModel = "";
      this.puertoModel = "";
      this.servicioIntegralModel = "";
      this.semanaModel = "";
    },
    closeReportModal() {
      this.ActionSetZindexTablaModal(false);
      this.actionSetPSShowReportModal(false);
      this.closeModal("reporte-ps-modal");
    },
    async generarReporte(type) {

      if (type === 2 && this.anioModel === "") {
        return this.$vToastify.error("Seleccione un año para el reporte anual", `Error en Año`);
      }

      this.$vToastify.loader("Exportando reporte planificaciones semanales...");

      this.actionSetPSEnabledButtons(false);

      await downloadReportePlanificacionSemanal({
          type: type,
          year: this.anioModel.id ?? null,
          client_id: this.clienteModel.id ?? null,
          container_id: this.contenedorModel.id ?? null,
          product_id: this.productoModel.id ?? null,
          port_id: this.puertoModel.id ?? null,
          integral_service: this.servicioIntegralModel.id ?? null,
          weeks_range: this.psCurrentWeeks ?? null,
          week: this.semanaModel ?? null
        },
        uuid.short("reporte-planificacion-semanal-ucc-")
      );

      this.closeReportModal();

      this.$vToastify.stopLoader();

      this.actionSetPSEnabledButtons(true);

    }
  },
  watch: {
    psShowReportModal: function(_new) {
      if (_new) {
        this.openModal("reporte-ps-modal");
      }
    }
  }
};
</script>

<style>

</style>